/**
 * แปลงแถวจาก RESTFUL_RESTOCKEST ให้เข้ากับ UI เดิม (purchase, mute, active, total_price ฯลฯ)
 */
export function normalizeRestockApiRow (row, { groupId, groupStock } = {}) {
  const r = { ...row }
  const orderAmt = Number(r.order_amt != null ? r.order_amt : 0)
  r.purchase = orderAmt
  const sp = Number(r.show_price != null ? r.show_price : 0)
  r.show_price = Number(+sp.toFixed(2))
  r.total_price = Number(+(sp * orderAmt).toFixed(2))

  const sw = r.suggest_word != null ? String(r.suggest_word).trim() : ''
  r.reason_name = sw !== '' ? sw : formatSuggestCodeThai(r.suggest_code)
  r.suggest_display = sw !== '' ? sw : r.reason_name

  if (r.active === undefined || r.active === null || r.active === '') {
    r.active = 'A'
  }
  r.deplete_alert = parseDepleteAlert(r)
  r.factor_multiply = parseFactorNumber(r.factor_multiply, 1)
  r.factor_plus = parseFactorNumber(r.factor_plus, 0)
  r.mute = isRestockAlertMuted(r.active)

  r.exp_date = r.first_expire
  r.Generic_name = r.Generic_name || r.Matdesc || ''
  r.item_name = [r.Generic_name, r.Matdesc].filter(Boolean).join(' ').trim() || r.Matdesc || ''

  if (groupId != null && (r.group_id === undefined || r.group_id === null || r.group_id === '')) {
    r.group_id = Number(groupId)
  }
  if (r.group_stock == null || r.group_stock === '') {
    r.group_stock = groupStock != null && groupStock !== 0 ? Number(groupStock) : Number(r.group_id)
  }

  const ul = r.unit_lot != null ? r.unit_lot : ''
  const ud = r.unit_dose != null ? r.unit_dose : ''
  r.lot_dose_display = [ul, ud].filter((x) => x !== '' && x != null).join(' / ')

  r.first_expire_display = formatExpireDdMmYyyy(r.first_expire)

  return r
}

/** อ่าน deplete_alert จากแถว API (หรือ parse จาก alert_set เช่น "<= 5.00") */
export function parseDepleteAlert (row) {
  const direct = row.deplete_alert ?? row.Deplete_alert
  if (direct != null && direct !== '' && !Number.isNaN(Number(direct))) {
    return Number(direct)
  }
  const alertSet = row.alert_set ?? row.alertSet
  if (alertSet != null) {
    const s = String(alertSet).trim()
    if (s && s !== '-') {
      const m = s.match(/<=\s*([\d.]+)/)
      if (m) return Number(m[1])
    }
  }
  return 0
}

function parseFactorNumber (v, fallback) {
  if (v != null && v !== '' && !Number.isNaN(Number(v))) return Number(v)
  return fallback
}

/** A/O = เปิดแจ้งเตือน, T/P/E = ระงับ/ยุติ */
export function isRestockAlertMuted (active) {
  const a = String(active ?? '').trim().toUpperCase()
  if (a === 'A' || a === 'O') return false
  if (a === 'T' || a === 'P' || a === 'E') return true
  return false
}

function formatExpireDdMmYyyy (v) {
  if (v == null || v === '' || v === '-') return '-'
  const s = String(v).trim()
  if (s.startsWith('1900-01-01')) return '-'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return '-'
  if (d.getUTCFullYear() === 1900 && d.getUTCMonth() === 0 && d.getUTCDate() === 1) {
    return '-'
  }
  const parts = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Asia/Bangkok'
  }).formatToParts(d)
  const day = parts.find((p) => p.type === 'day')?.value ?? '01'
  const month = parts.find((p) => p.type === 'month')?.value ?? '01'
  const year = parts.find((p) => p.type === 'year')?.value ?? '1900'
  return `${day}-${month}-${year}`
}

function formatSuggestCodeThai (code) {
  if (code == null || code === '') return '—'
  const s = String(code).trim()
  if (s === '-' || s === '—') return '—'
  const n = Number(s)
  if (!Number.isNaN(n)) {
    if (n <= -2) return 'ขาดแคลนอย่างหนัก'
    if (n === -1) return 'ขาดแคลน'
    if (n === 0) return 'เพียงพอ'
    if (n >= 1) return 'เกินความจำเป็น'
  }
  return s
}
